export default "__VITE_ASSET__DykuHiv3__"